import styled from 'styled-components';

export const PairingStep = styled.div`
  #team-sizes {
    text-align: center;

    .team-size {
      width: 100%;
      font-size: 3em;
      background: rgba(255, 255, 255, 0.5);
      border: 1px solid gray;
      border-radius: 15px;
      display: inline-block;

      &:hover {
        color: #470b03;
        box-shadow: 10px 5px 5px 1px rgba(0, 0, 0, 0.5);
      }
    }
  }
`;
